module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraLight.009336d.ttf";